export default {
    userSelectText: {
        userSelect: 'text',
        WebkitUserSelect: 'text',
    },
    userSelectNone: {
        userSelect: 'none',
        WebkitUserSelect: 'none',
    },
};
